import styled from 'styled-components';

import Box from './Box';

const Heading = styled(Box)`
  span {
    font-size: 16px;
    font-weight: 400;
    font-style: normal;
    line-height: 28px;
  }
`;

export default Heading;
